import Bowser from 'bowser';

/**
 * Same rule as the Onboarding Widget requirements step (Bowser platform type,
 * tablets count as mobile), so that `mobileOnly` and the OBW `deviceType`
 * check give the same answer for the same device.
 */
export const isMobile = async () => {
  const { type } = Bowser.parse(navigator.userAgent).platform;
  return type === 'mobile' || type === 'tablet';
};
